(function () {
  if (window.__spCartB2B) return;
  window.__spCartB2B = 1;

  var SP_B2B = {
    enabled: false,

    isApplied: function (totalEl) { return true; },

    netText: function (priceEl) { return priceEl ? priceEl.textContent : ''; },

    reconstructSplit: function (bd, netUnit) { return null; }
  };

  var MIN_SHOW_MS = 350;
  var SETTLE_MS = 600;
  var MAX_MASK_MS = 6000;
  var FALLBACK_MS = 1000;
  var SUPPRESS_RELOAD_RERENDER = true;

  if (SP_B2B.enabled && SUPPRESS_RELOAD_RERENDER && typeof window.fetch === 'function' && typeof window.Response === 'function') {
    var spStart = Date.now();
    var spActed = false;
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, function () { spActed = true; }, { capture: true });
    });
    var spFetch = window.fetch;
    window.fetch = function (input) {
      try {
        var u = '' + ((input && input.url) || input);
        if (/[?&]sections=/.test(u) && /lazyload=false/.test(u) && !spActed && (Date.now() - spStart) < 6000) {
          return Promise.resolve(new Response('null', { status: 200, headers: { 'Content-Type': 'application/json' } }));
        }
      } catch (e) {}
      return spFetch.apply(this, arguments);
    };
  }

  function parseMoneyToCents(text) {
    if (!text) return NaN;
    var cleaned = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    if (!cleaned) return NaN;
    var val = parseFloat(cleaned);
    return isNaN(val) ? NaN : Math.round(val * 100);
  }

  function formatMoney(cents) {
    var fmt = (window.SPCore && SPCore.settings && SPCore.settings.moneyFormat) || '${{amount}}';
    function num(n, decimals, thousands, decimal) {
      var parts = (n / 100).toFixed(decimals).split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? intPart + decimal + parts[1] : intPart;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_space_separator': return num(cents, 2, ' ', '.');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  function setHTML(el, html) { if (el && el.innerHTML !== html) el.innerHTML = html; }
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function toggle(el, cls, on) { if (el && el.classList.contains(cls) !== on) el.classList.toggle(cls, on); }

  function priceApplied(el) {
    var text = el.textContent.trim();
    if (el.__spInitial == null) { el.__spInitial = text; el.__spSeen = Date.now(); }
    if (SP_B2B.isApplied(el)) return true;
    if (text !== el.__spInitial) return true;
    if (Date.now() - el.__spSeen >= FALLBACK_MS) return true;
    if (!el.__spTimer) {
      el.__spTimer = setTimeout(function () { el.__spTimer = null; updateAll(); }, FALLBACK_MS - (Date.now() - el.__spSeen) + 50);
    }
    return false;
  }

  function syncMask() {
    var cart = document.querySelector('[data-section-type="cart-template"]');
    if (!cart) return;
    if (!SP_B2B.enabled) { toggle(cart, 'is-price-pending', false); cart.__spMaskStart = null; return; }

    var totalEl = cart.querySelector('[data-sp-cart-total]');
    if (!totalEl) { toggle(cart, 'is-price-pending', false); cart.__spMaskStart = null; return; }

    var now = Date.now();
    var applied = priceApplied(totalEl);
    if (!applied || cart.__spLastUnstable == null) cart.__spLastUnstable = now;
    var stableFor = now - cart.__spLastUnstable;

    var shouldMask = !applied || stableFor < SETTLE_MS;
    if (shouldMask && cart.__spMaskStart == null) cart.__spMaskStart = now;

    var maskedFor = cart.__spMaskStart != null ? now - cart.__spMaskStart : 0;
    var reveal = cart.__spMaskStart == null
      ? true
      : ((!shouldMask && maskedFor >= MIN_SHOW_MS) || maskedFor >= MAX_MASK_MS);

    toggle(cart, 'is-price-pending', !reveal);

    if (reveal) {
      cart.__spMaskStart = null;
    } else if (!cart.__spTick) {
      cart.__spTick = setTimeout(function () { cart.__spTick = null; updateAll(); }, 150);
    }
  }

  function updateBar(bar) {
    var footer = bar.closest('.cart-footer') || document;
    var totalEl = footer.querySelector('[data-sp-cart-total]')
              || document.querySelector('[data-sp-cart-total]');
    if (!totalEl) return;

    var threshold = Number(bar.getAttribute('data-amount-cents'));
    if (!threshold) return;
    if (!priceApplied(totalEl)) return;

    var cents = parseMoneyToCents(SP_B2B.netText(totalEl));
    if (isNaN(cents)) return;

    bar.style.setProperty('--shipping-bar-progress-value', Math.min((cents / threshold) * 100, 100) + '%');
    bar.setAttribute('data-cart-total', cents);

    var label = bar.querySelector('.js-cart-shipping-label');
    var amountMsg = bar.querySelector('.js-cart-shipping-amount-msg');
    var icon = bar.querySelector('.js-cart-shipping-icon');
    var progressBar = bar.querySelector('.js-cart-shipping-progress-bar');
    var hidden = bar.querySelector('.js-shipping-bar-progress-hidden-text');

    var met = cents >= threshold;
    if (met) {
      var success = bar.getAttribute('data-success-message') || '';
      setHTML(amountMsg, success);
      setText(hidden, success);
    } else {
      var remaining = formatMoney(threshold - cents);
      var tmpl = bar.getAttribute('data-amount-message') || '';
      setHTML(amountMsg, tmpl.replace('{amount}', '<strong>' + remaining + '</strong>'));
      setText(hidden, tmpl.replace('{amount}', remaining));
    }
    toggle(label, 'cart-shipping__label--success', met);
    toggle(icon, 'is-hidden', !met);
    toggle(progressBar, 'is-hidden', met);
  }

  function formatUnit(lineCents, qty, decimals, suffix, negative) {
    if (!qty) return '';
    var centsPerUnit = Math.round(Math.abs(lineCents) / qty);
    var v = (centsPerUnit / 100).toFixed(decimals);
    var fmt = (window.SPCore && SPCore.settings && SPCore.settings.moneyFormat) || '${{amount}}';
    return (negative && centsPerUnit !== 0 ? '-' : '') + fmt.replace(/\{\{\s*\w+\s*\}\}/, v) + suffix;
  }
  function setRowUnit(row, lineCents, qty, negative) {
    if (!row) return;
    var wide = row.querySelector('.js-bd-unit-wide');
    var compact = row.querySelector('.js-bd-unit-compact');
    if (wide) setText(wide, formatUnit(lineCents, qty, 2, ' ea', negative));
    if (compact) setText(compact, formatUnit(lineCents, qty, 2, '/unit', negative));
  }

  function updateBreakdowns(cart) {
    var pending = cart.classList.contains('is-price-pending');
    var sumQb = 0, sumCp = 0;
    cart.querySelectorAll('.js-cart-breakdown').forEach(function (bd) {
      var original = parseInt(bd.getAttribute('data-bd-original'), 10);
      var shopify = parseInt(bd.getAttribute('data-bd-shopify'), 10) || 0;
      var qty = parseInt(bd.getAttribute('data-bd-qty'), 10);
      var totalEl = bd.querySelector('[data-sp-line-total]');
      var baseRow = bd.querySelector('.cart-item__bd-row--base');
      var totalRow = bd.querySelector('.cart-item__bd-row--total');
      var qbRow = bd.querySelector('.js-cart-bd-qbreak');
      var qbVal = bd.querySelector('.js-cart-bd-qbreak-value');
      var whRow = bd.querySelector('.js-cart-bd-wholesale');
      var whVal = bd.querySelector('.js-cart-bd-wholesale-value');
      if (isNaN(original) || !totalEl || !whRow) return;

      var unit = parseInt(bd.getAttribute('data-bd-unit'), 10);
      var netCents = parseMoneyToCents(SP_B2B.netText(totalEl));
      var netUnit = (!isNaN(netCents) && qty) ? Math.round(netCents / qty) : NaN;
      var totalDisc = isNaN(netCents) ? 0 : original - shopify - netCents;

      setRowUnit(baseRow, original, qty, false);
      if (!isNaN(netCents)) setRowUnit(totalRow, netCents, qty, false);

      var qbShow = false, whShow = false, qbAmt = 0, cpAmt = 0;
      if (!pending && totalDisc >= 1) {
        var split = SP_B2B.reconstructSplit(bd, netUnit);
        if (split && split.qb >= 1) {
          qbAmt = split.qb; cpAmt = split.cp;
          setText(qbVal, '-' + formatMoney(qbAmt));
          setText(whVal, '-' + formatMoney(cpAmt));
          setRowUnit(qbRow, qbAmt, qty, true);
          setRowUnit(whRow, cpAmt, qty, true);
          qbShow = true;
          whShow = cpAmt >= 1;
        } else {
          cpAmt = isNaN(netUnit) ? totalDisc : (unit - netUnit) * qty;
          setText(whVal, '-' + formatMoney(cpAmt));
          setRowUnit(whRow, cpAmt, qty, true);
          whShow = cpAmt >= 1;
        }
        sumQb += qbAmt;
        sumCp += cpAmt;
      }

      if (qbRow && qbRow.hidden !== !qbShow) qbRow.hidden = !qbShow;
      if (whRow.hidden !== !whShow) whRow.hidden = !whShow;
      toggle(bd, 'is-discounted', shopify > 0 || qbShow || whShow);
    });

    updateOrderBreakdown(cart, pending, sumQb, sumCp);
  }

  function updateOrderBreakdown(cart, pending, sumQb, sumCp) {
    var box = cart.querySelector('.js-cart-order-breakdown');
    if (!box) return;
    var qbRow = box.querySelector('.js-order-qbreak');
    var whRow = box.querySelector('.js-order-wholesale');
    var qbShow = !pending && sumQb >= 1;
    var whShow = !pending && sumCp >= 1;
    if (qbShow) setText(box.querySelector('.js-order-qbreak-value'), '-' + formatMoney(sumQb));
    if (whShow) setText(box.querySelector('.js-order-wholesale-value'), '-' + formatMoney(sumCp));
    if (qbRow && qbRow.hidden !== !qbShow) qbRow.hidden = !qbShow;
    if (whRow && whRow.hidden !== !whShow) whRow.hidden = !whShow;
    var show = qbShow || whShow;
    if (box.hidden !== !show) box.hidden = !show;
  }

  function updateAll() {
    syncMask();
    document.querySelectorAll('.js-sp-shipping').forEach(updateBar);
    var cart = document.querySelector('[data-section-type="cart-template"]');
    if (cart) updateBreakdowns(cart);
  }

  function init() {
    var run = (window.SPCore && SPCore.utils && SPCore.utils.throttle)
      ? SPCore.utils.throttle(updateAll)
      : function () { window.requestAnimationFrame(updateAll); };
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (window.SPCore && SPCore.DOMready) {
    SPCore.DOMready(init);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
